import React from 'react';
import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';
import { Modal, Button } from 'fpay-ui';
import { useTranslation } from 'react-i18next';

import { useBreakpoints } from '@hooks/NewBreakpoint';
import { fogEmail } from '@helpers';

import { getEnv } from '@config';

const { publicPath } = getEnv();

const Container = styled.div`
  word-break: break-word;
`;

const ImageContainer = styled.div`
  text-align: center;
`;

const Image = styled.img`
  width: 120px;
  margin-top: 24px;
`;

const Title = styled.h2(
  ({ theme }) => css`
    ${theme.textTypes['H6-w400']}
    color: ${theme.colors.gray800};
    margin-bottom: 16px;
    margin-top: 0;
  `
);

const Paragraph = styled.p(
  ({ theme }) => css`
    ${theme.textTypes['Body-2-w400']}
    color: ${theme.colors.gray600};
  `
);

const EmailSentModal = ({ email, handleConfirm, handleClose }) => {
  const { t } = useTranslation();
  const { breakpoint } = useBreakpoints();

  return (
    <Modal
      paddingLeft="24px"
      paddingRight="24px"
      showCloseButton
      fClose={handleClose}
      width={breakpoint === 'xs' ? '312px' : '400px'}
    >
      <Container>
        <Title data-testid="email-sent-modal-title">
          {t('commerceData.editRepresentant.emailConfirmation.title')}
        </Title>
        <Paragraph data-testid="email-sent-modal-body">
          {t('commerceData.editRepresentant.emailConfirmation.body', {
            email: fogEmail(email),
          })}
        </Paragraph>
        <ImageContainer>
          <Image src={`${publicPath}/email.svg`} alt="Imagen de email" id="icono-email" />
        </ImageContainer>
        <Button
          data-testid="email-sent-modal-button"
          size="large"
          onClick={handleConfirm}
          style={{
            width: breakpoint === 'xs' ? '156px' : '200px',
            height: '40px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '32px auto',
          }}
        >
          {t('commerceData.editRepresentant.emailConfirmation.confirm')}
        </Button>
      </Container>
    </Modal>
  );
};

EmailSentModal.propsTypes = {
  email: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
};

export default EmailSentModal;
